// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3AXiJ","actions":"GroupTable_actions__3MI-o","deleteModalFooter":"GroupTable_deleteModalFooter__2Y8B7"};